import {Observable}                from 'rxjs';
import {distinctUntilChanged, map} from 'rxjs/operators';

import IPlaybackQuality from '../../../Solutions/Shared/Interfaces/IPlaybackQuality';
import Playback         from '../../../State/Stores/Playback/Playback';

const createPlaybackQualityChangeStream = (
    playbackStoreUpdate$: Observable<Playback>
): Observable<IPlaybackQuality> =>
    playbackStoreUpdate$
        .pipe(
            distinctUntilChanged((prev, next) =>
                prev.bitrate === next.bitrate &&
                prev.resolution === next.resolution
            ),
            map(({bitrate, resolution, estimatedBandwidth}) => ({bitrate, resolution, estimatedBandwidth}))
        );

export default createPlaybackQualityChangeStream;